import { useMemo } from 'react';

import useForm from '../utils/useForm';
import { US_STATES } from '../../constants/formOptions';

const useContactForm = (onSubmit, values, title) => {
  const fields = useMemo(
    () => [
      {
        title,
        fields: [
          {
            title: 'Name',
            name: 'name',
            type: 'text',
            required: true,
          },
          {
            title: 'Email',
            name: 'email',
            type: 'text',
            required: true,
            validation: 'email',
          },
          {
            title: 'Phone',
            name: 'phone',
            type: 'text',
            validation: 'phone',
            mask: '(999) 999-9999',
          },
          {
            title: 'Address Line 1',
            name: 'address_line_1',
            type: 'text',
          },
          {
            title: 'Address Line 2',
            name: 'address_line_2',
            type: 'text',
          },
          {
            title: 'City',
            name: 'city',
            type: 'text',
          },
          {
            title: 'State',
            name: 'state',
            type: 'select',
            options: US_STATES,
          },
          {
            title: 'ZIP',
            name: 'zip',
            type: 'text',
            validation: 'zip',
          },
        ],
      },
    ],
    [title]
  );

  return useForm({ fields, onSubmit, values });
};

export default useContactForm;
